import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { useEmbeddingContext } from "../../hooks";

import { FlexContainers, WrapperContainer } from "../../components";
import { DashboardContainer, IFrameContainer } from "./styled";

const SmartDashboardContainer = ({ dashboardUrl, isQnAUrl }) => {
  const embeddingContext = useEmbeddingContext();
  const embeddedDashboardExperienceRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!dashboardUrl || !containerRef.current) return;
    const initDashboard = async () => {
      const { embedDashboard, embedGenerativeQnA } = embeddingContext;

      const frameOptions = {
        url: dashboardUrl,
        container: containerRef.current,
        withIframePlaceholder: true,
        height: "100%",
        width: "100%"
      };
      const contentOptions = {
        toolbarOptions: {
          export: true,
          reset: true
        }
      };

      containerRef.current.innerHTML = "";
      embeddedDashboardExperienceRef.current = isQnAUrl
        ? await embedGenerativeQnA(frameOptions, contentOptions)
        : await embedDashboard(frameOptions, contentOptions);
    };

    initDashboard();
  }, [dashboardUrl]);

  return (
    <WrapperContainer Container={DashboardContainer} height="100%" width="100%">
      <IFrameContainer innerRef={containerRef} Container={FlexContainers.FlexRowCenter} />
    </WrapperContainer>
  );
};

SmartDashboardContainer.propTypes = {
  dashboardUrl: PropTypes.string,
  isQnAUrl: PropTypes.bool
};

export default SmartDashboardContainer;
